import { Component } from '@angular/core';
import { ScrBaseComponent } from '../../../base.component';
import { PendingOrderService, ScrAuthenticationService } from 'src/app/services';
import { ConfirmationService } from 'primeng/api';
import { NavigationExtras, Router, UrlTree } from '@angular/router';

@Component({
  selector: 'app-linked-accounts-navigator',
  templateUrl: './linked-accounts-navigator.component.html'
})
export class LinkedAccountsNavigatorComponent extends ScrBaseComponent {

  constructor(
    private router: Router,
    private pendingOrderService: PendingOrderService,
    private scrAuthenticationService: ScrAuthenticationService,
    private confirmationService: ConfirmationService) {
    super();
  }

  linkedAccountConfirm(accountId: number, fct: () => void): void {
    this.confirmationService.confirm({
      message:
        'Please confirm that you would like to log out of your account and log in to the selected linked account.' +
        '  If you have an unfinished order in your cart, this action will remove the cart contents and cancel the unfinished order.',
      header: 'Log In to Linked Account',
      key: 'confirmLoginAs',
      accept: () => {

        this.observe(this.scrAuthenticationService.getLinkedAccountPermissionForAccount(accountId), rsp => {
          // no refresh token...
          rsp.refreshToken = '';
          this.pendingOrderService.clear();
          this.pendingOrderService.removeMarketBrochureStorage();

          fct();
        });
      }
    });
  }

  loginAs(accountId: number, urlTree?: UrlTree, extras?: NavigationExtras): void {
    this.linkedAccountConfirm(accountId, () => {
      if (!urlTree) {
        urlTree = this.router.createUrlTree(['dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list'] } }] } }]);
      }
      this.router.navigateByUrl(urlTree, extras);
    });
  }
}




